import React, { useMemo } from "react"
import { Stack } from "@mui/material"

import PSESearchBar from "./PSESearchBar"
import PSEsTabs from "./PSEsTabs"
import { PSES_SIDEBAR_MENUS_ENUM, PSES_SIDEBAR_WIDTH, PSES_STATUS_TABS } from "../../utils/productionStepExecution"
import TypeFilter from "../../components/Filter/TypeFilter"
import { TRANSFORMATION_TYPES } from "../../utils/supplierItemUtils"
import { getTileChips, PSE_TILE_VISUALS } from "../../utils/tiles"
import { withoutMachineName } from "../../utils/machinesutils"

const options = [
	{ value: PSES_STATUS_TABS.TODO, label: "À démarrer" },
	{ value: PSES_STATUS_TABS.IN_PROGRESS, label: "En cours" },
	{ value: PSES_STATUS_TABS.LOCKED, label: "En attente" },
	{ value: PSES_STATUS_TABS.DONE, label: "Terminées" },
]

const ProductionStepExecutionsFilters = ({
	PSETiles,
	filters,
	onFilterChange,
	selectedStatus,
	onStatusChange,
	isSidebarExpanded,
	selectedMenu,
	tabs,
	statusCounts = {},
}) => {
	const machinesBatchOptions = useMemo(() => {
		if (selectedMenu === PSES_SIDEBAR_MENUS_ENUM.TASTING) return []

		const machines = Array.from(new Set(PSETiles.map(pse => pse.machinesBatch).filter(Boolean)))
			.flat()
			.map(machine => machine.machineName)
			.filter((v, i, a) => a.indexOf(v) === i)

		const machineNames = (machines.length === 1 && machines[0] === withoutMachineName) ? [] : machines
		
		const options = machineNames.map(name => ({ value: name, label: name }))
		return options
	}, [PSETiles, selectedMenu])

	const transformationTypesOptions = useMemo(() => {
		if (selectedMenu === PSES_SIDEBAR_MENUS_ENUM.TASTING) return []

		const transformationTypes = Array.from(new Set(PSETiles.map(pse => pse.productionStepSnapshot?.transformation)
			.filter(Boolean)))
		const filteredTransformationTypes = TRANSFORMATION_TYPES.filter(t => transformationTypes.includes(t.value))
		return filteredTransformationTypes
	}, [PSETiles])

	const specificityOptions = useMemo(() => {
		const filteredSpecificityOptions = Object.keys(PSE_TILE_VISUALS)
			.map(status => (
				{
					value: PSE_TILE_VISUALS[status].label,
					label: PSE_TILE_VISUALS[status].label
				}))
			.filter(statusObj => statusObj.label)

		const pseSpecificities = Array.from(new Set(PSETiles.reduce((acc, pse) => {
			const chips = getTileChips(pse)
			chips.forEach(chip => {
				if (chip.label) {
					acc.push(chip.label)
				}
			})
			return acc
		}, [])))
		const filteredPseSpecificities = filteredSpecificityOptions.filter(specificity => pseSpecificities.includes(specificity.label))
		return filteredPseSpecificities
	}, [PSETiles])

	const handleSearchChange = (e) => {
		const value = e.target.value
		if (onFilterChange) {
			onFilterChange({ searchText: value })
		}
	}

	const handleStatusChipClick = (status) => {
		onFilterChange({ status })
		if (onStatusChange) {
			onStatusChange(status)
		}
	}

	return (
		<Stack spacing={6}>
			{/* Top - search and filters */}
			<Stack spacing={3} style={{ width: "100%" }}>
				{/* Search bar */}
				<PSESearchBar
					value={filters.searchText}
					onChange={handleSearchChange}
					placeholder="Rechercher une étape une section ou une recette"
				/>

				<Stack
					spacing={3}
					sx={{
						// Scrollable on small screens
						"@media (max-width: 983px)": {
							overflowX: "scroll",
							// Reduce width based on sidebar state
							width: `calc(100vw - ${(isSidebarExpanded ? PSES_SIDEBAR_WIDTH.EXPANDED : PSES_SIDEBAR_WIDTH.COLLAPSED) + (24 * 2)}px)`,
						},
					}}
				>
					{/* Filter dropdowns row */}
					<TypeFilter
						specificity={specificityOptions}
						machinesBatch={machinesBatchOptions}
						transformationTypes={transformationTypesOptions}
						value={filters}
						onChange={onFilterChange}
					/>

					{/* Bottom - status tabs */}
					{/* {selectedMenu !== PSES_SIDEBAR_MENUS_ENUM.TASTING && ( */}
					<PSEsTabs
						tab={selectedStatus}
						onTabChange={handleStatusChipClick}
						notificationCount={statusCounts}
						options={options}
						tabs={tabs}
						selectedMenu={selectedMenu}
					/>
					{/* )} */}
				</Stack>
			</Stack>
		</Stack>
	)
}

export default ProductionStepExecutionsFilters